import { useEffect, useState } from "react";
import client from "../../utils/client";
import { Box, Flex, Image, Link, Skeleton, Text } from "@chakra-ui/react";

const parseEndDate = (str) => {
  if (!str) return null;
  const iso = /^\d{4}-\d{2}-\d{2}/;
  const br = /^\d{2}\/\d{2}\/\d{4}$/;
  try {
    if (iso.test(str)) return new Date(str.split("T")[0] + "T23:59:59-03:00");
    if (br.test(str)) {
      const [dd, mm, yyyy] = str.split("/");
      return new Date(`${yyyy}-${mm}-${dd}T23:59:59-03:00`);
    }
    const d = new Date(str);
    return isNaN(d) ? null : d;
  } catch { return null; }
};

const SponsorBanner = () => {
  const [principal, setPrincipal] = useState([]);
  const [secundario, setSecundario] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await client.get("/sponsors");
        const items = res?.data?.sponsorItems ?? [];
        const now = new Date();
        const active = items.filter((s) => {
          if (s?.isActive?.trim().toLowerCase() !== "ativo") return false;
          const end = parseEndDate(s?.endDate);
          return end && end.getTime() >= now.getTime();
        });
        setPrincipal(active.filter((s) => s.type === "Principal"));
        setSecundario(active.filter((s) => s.type === "Secundário"));
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (!isLoading && principal.length === 0 && secundario.length === 0) return null;

  return (
    <Skeleton isLoaded={!isLoading}>
      <Box bg="white" borderTop="3px solid" borderColor="green.400" py={[6, 8]} px={[4, 6, 8]}>
        <Box maxW="1400px" mx="auto">
          {principal.length > 0 && (
            <Box mb={secundario.length > 0 ? 6 : 0}>
              <Text
                fontSize="0.72rem"
                fontWeight={700}
                letterSpacing="0.12em"
                color="gray.400"
                textTransform="uppercase"
                textAlign="center"
                mb={4}
              >
                Patrocinadores Principais
              </Text>
              <Flex gap={6} wrap="wrap" justifyContent="center" alignItems="center">
                {principal.map((s) => (
                  <Link
                    key={s.sponsorId}
                    href={s.targetUrl}
                    isExternal
                    _hover={{ opacity: 0.8 }}
                    transition="opacity 0.2s"
                  >
                    <Image
                      src={`${process.env.REACT_APP_S3_BASEURL}/sponsors_images/${s?.images?.[0] ?? ""}`}
                      h={["60px", "80px"]}
                      objectFit="contain"
                      filter="grayscale(20%)"
                      _hover={{ filter: "grayscale(0%)" }}
                      transition="filter 0.2s"
                    />
                  </Link>
                ))}
              </Flex>
            </Box>
          )}

          {secundario.length > 0 && (
            <Box>
              <Text
                fontSize="0.68rem"
                fontWeight={700}
                letterSpacing="0.12em"
                color="gray.300"
                textTransform="uppercase"
                textAlign="center"
                mb={3}
              >
                Apoiadores
              </Text>
              <Flex gap={4} wrap="wrap" justifyContent="center" alignItems="center">
                {secundario.map((s) => (
                  <Link
                    key={s.sponsorId}
                    href={s.targetUrl}
                    isExternal
                    _hover={{ opacity: 0.8 }}
                    transition="opacity 0.2s"
                  >
                    <Image
                      src={`${process.env.REACT_APP_S3_BASEURL}/sponsors_images/${s?.images?.[0] ?? ""}`}
                      h={["30px", "40px"]}
                      objectFit="contain"
                      filter="grayscale(40%)"
                      _hover={{ filter: "grayscale(0%)" }}
                      transition="filter 0.2s"
                    />
                  </Link>
                ))}
              </Flex>
            </Box>
          )}
        </Box>
      </Box>
    </Skeleton>
  );
};

export default SponsorBanner;
